import React from "react";

const SmallHeading = (props) => {
  const { heading } = props;
  return (
    <div className="mt-4">
      <span className="graphikFont">{heading}</span>
    </div>
  );
};

export default SmallHeading;
